import { TSCMSimulationGraphData } from 'src/features/Results/SingleAreaResults';
import { TProfileResults } from 'src/hooks/useResults';

export const pickKpiData = function (obj: TProfileResults): TSCMSimulationGraphData {
  if (!obj || !obj?.kpi || !obj?.billsEnergy) return [];

  return obj.kpi
    .filter((item) => item.simulation_time)
    .map((item) => {
      const sold: number =
        ((obj.billsEnergy?.find((bill) => bill.simulation_time === item.simulation_time)
          ?.sold_to_grid || 0) as number) * 1000;

      return {
        time: item.simulation_time,
        consumption: item.energy_demanded_kwh * 1000,
        generation: item.energy_produced_kwh * 1000,
        sold: Math.round(sold * 100) / 100,
      };
    });
};
